var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaveGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 786,
    height: 277,
    viewBox: "0 0 786 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 168.298C70.809 168.298 33.63 7.5 76.8675 7.5C121.654 7.5 98.2404 269.5 146.214 269.5C192.283 269.5 169.426 29.9893 215.581 29.9893C260.039 29.9893 236.83 247.011 284.97 247.011C330.801 247.011 308.451 52.4785 354.338 52.4785C398.216 52.4785 368.368 224.521 423.684 224.521C479 224.521 444.456 80.2607 489.745 80.2607C532.566 80.2607 512.274 202.456 552.502 202.456C586.657 202.456 572.575 103.115 610 103.115C647.425 103.115 635.264 190.788 668.192 190.788C698.085 190.788 687.272 124.357 714.066 124.357C740.86 124.357 724.496 178.729 758.662 178.729C766.928 178.729 771.887 175.992 778.5 167.611",
    stroke: "url(#paint0_linear_1055_61109)",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1055_61109",
    x1: 355,
    y1: 138.5,
    x2: 778.5,
    y2: 138.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37D2CD",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BEF4A",
    stopOpacity: 0.4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveGreen);
export default __webpack_public_path__ + "static/media/wave_green.2d081a0bede94cb20786a04e2d7f86e7.svg";
export { ForwardRef as ReactComponent };